import React, { useState, useEffect } from 'react';
import { Modal, Form, Tabs } from 'antd';
import axios from 'axios';
import NewTourForm from '../../listing/appointments/appointment_booking/virtual_tour/NewTourForm';
import VirtualTourGuestForm from './VirtualTourGuestForm';

const { TabPane } = Tabs;

interface EditTourDetailsModalContainerProps {
  modalVisible: boolean;
  onCancel: () => void;
  virtualTour: any;
  setVirtualTour: any;
  retsId: string;
  dashboardId: string;
}

const EditTourDetailsModalContainer: React.FC<
  EditTourDetailsModalContainerProps
> = ({
  modalVisible,
  onCancel,
  virtualTour,
  setVirtualTour,
  retsId,
  dashboardId,
}) => {
  const isExternal = retsId || dashboardId;
  const modalTitle = <h1 style={{ textAlign: 'center' }}>Edit Tour Details</h1>;
  const [form] = Form.useForm();
  const [activeKey, setActiveKey] = useState('1');
  const [tourName, setTourName] = useState(virtualTour.tourName);
  const [tourDate, setTourDate] = useState(virtualTour.startTime);
  const [guests, setGuests] = useState(virtualTour.invitees);

  const [isError, setIsError] = useState(false);

  useEffect(() => {
    setGuests(virtualTour.invitees || []);
  }, [virtualTour]);

  const onSubmit = async () => {
    form
      .validateFields()
      .then(async values => {
        setGuests(values.guests);
        const { data: savedTour } = await axios.post(
          isExternal
            ? `/external/virtual_tour/${virtualTour.id}`
            : `/virtual_tour/${virtualTour.id}`,
          {
            tourName,
            startTime: tourDate,
            invitees: values.guests || guests,
            retsId,
            dashboardId,
          },
        );
        onCancel();
        setVirtualTour(savedTour);
      })
      .catch(info => {
        // if form validation failed, switch to tab 2
        setActiveKey('2');
        console.log('Validate Failed:', info);
      });
  };

  const onChangeTab = (key: string) => {
    setActiveKey(key);
  };

  return (
    <Modal
      data-cy="modal-popup"
      width={800}
      centered
      okText="Save"
      title={modalTitle}
      open={modalVisible}
      onOk={() => onSubmit()}
      onCancel={() => onCancel()}
    >
      <Tabs defaultActiveKey="1" activeKey={activeKey} onChange={onChangeTab}>
        <TabPane tab="Tour Details" key="1">
          <NewTourForm
            setIsError={setIsError}
            setTourName={setTourName}
            setTourDate={setTourDate}
            tourDate={tourDate}
            tourName={tourName}
          />
        </TabPane>
        <TabPane tab="Manage Guests" key="2">
          <VirtualTourGuestForm existingGuests={guests} form={form} />
        </TabPane>
      </Tabs>
    </Modal>
  );
};

export default EditTourDetailsModalContainer;
